<template>
  <div id="app">
    <router-view :key="$route.fullPath" class="main"></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app'
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #ededed;;
  }
  .el-image-viewer__close{
    color: #FFFFFF !important;
  }
  .el-image-viewer__bt{
    color: #FFFFFF !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5299877d